module.exports = __webpack_public_path__ + "img/rock-big-07.6c7a6590.png";